const UsersList = ({ context }) => {
  console.log(context.users);
  return (
    <>
      <div className='col-12'>
        <div className='d-flex flex-row align-items-center my-3'>
          <i className='far fa-users f-18 text-dark'></i>
          <span className='text-dark f-14 font-weight-bold mx-2'>
            لیست شرکت کنندگان انفرادی
          </span>
        </div>

        {context?.users?.length > 0 ? (
          <table
            className='table table-striped my-3 text-left'
            style={{ minWidth: '992px' }}
          >
            <thead>
              <tr className='bg-purple text-white'>
                <th scope='col'>#</th>
                <th scope='col'>نام و نام خانوادگی</th>
                <th scope='col'>کد ملی</th>
                <th scope='col'>استان محل زندگی</th>
                <th scope='col'>زورخانه</th>
                <th scope='col'>رشته</th>
                <th scope='col'>وزن</th>
                <th scope='col'>رده سنی</th>
              </tr>
            </thead>
            <tbody>
              {context?.users?.map((user, index) => (
                <tr key={user?.id}>
                  <th scope='row'>{index + 1}</th>
                  <td>
                    {user?.name} {user?.last_name}
                  </td>
                  <td>{user?.national_card_id}</td>
                  <td>{user?.province_living?.name}</td>
                  <td>{user?.gym?.name}</td>
                  <td>{user?.sport_id?.map((s) => s?.title + ',')}</td>
                  <td>
                    {
                      context.competition?.weights?.find(
                        (s) => s?.id == user?.weight_id,
                      )?.weight
                    }
                  </td>
                  <td>
                    {
                      context.competition?.ages?.find(
                        (s) => s?.id == user?.age_id,
                      )?.title
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center align-items-center my-3'>
            اطلاعاتی جهت نمایش یافت نشد.
          </div>
        )}
      </div>
    </>
  );
};

export default UsersList;
